import { List } from '@apollo/orbit';
import React from 'react';

import { DescriptionTermListItem } from './DescriptionTermListItem';

type Header = [string, string];

export interface Props {
  headers: Header[] | undefined;
  className?: string;
}

export const HeadersList = ({ headers = [], className }: Props) => (
  <List as="dl" className={className}>
    {headers.map(([headerKey, headerValue]) => (
      <DescriptionTermListItem
        term={headerKey}
        details={headerValue}
        key={headerKey + headerValue}
      />
    ))}
  </List>
);
